document.addEventListener("DOMContentLoaded", function () {
  const slideInItems = document.querySelectorAll(".slide-up-animated");
  if (!slideInItems) return;
  slideInItems.forEach((item) => {
    item.classList.add("animation-start");
  });
});
function getSliderSettings() {
  return {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
}

function getSubSliderProductSettings() {
  return {
    slidesPerView: "auto",
    direction: "vertical",
    navigation: false,
  };
}

function updatethumbnail() {
  if (document.querySelector(".quick-add-modal .product__media-list")) {
    let productList = document.querySelector(
      ".quick-add-modal .product__media-list"
    );
    let mediaHeight = productList && productList.offsetHeight;
    let mediaThumbHeight = document.querySelector(
      ".quick-add-modal .product__media-sublist"
    );
    if (mediaThumbHeight) {
      if (window.innerWidth > 576) {
        mediaThumbHeight.style.height = mediaHeight + "px";
      }
      if (window.innerWidth < 576) {
        mediaThumbHeight.style.height = 100 + "%";
      }
    }
  }
  // else {
  //	let productList = document.querySelector(
  //		".product-section .product__media-list"
  //	);
  //	let mediaHeight = productList && productList.offsetHeight;
  //	console.log("productList.offsetHeight --- " + productList.offsetHeight);
  //	console.log("mediaHeight --- " + mediaHeight);

  //	let mediaThumbHeight = document.querySelector(
  //		".product-section .product__media-sublist"
  //	);
  //	if (mediaThumbHeight) {
  //		if (window.innerWidth > 576) {
  //			mediaThumbHeight.style.height = mediaHeight + "px";
  //		}
  //		if (window.innerWidth < 576) {
  //			mediaThumbHeight.style.height = 100 + "%";
  //		}
  //	}
  //}
}

const sliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-list") &&
    document.querySelectorAll(".js-media-list").length > 0
  ) {
    document.querySelectorAll(".js-media-list").forEach((elem, index) => {
      let slider = new Swiper(elem, {
        slidesPerView: 1,
        //autoHeight: true,
        spaceBetween: 24,
        navigation: {
          nextEl: ".swiper-btn--next",
          prevEl: ".swiper-btn--prev",
        },
        thumbs: {
          swiper: document.querySelectorAll(".js-media-sublist")[index].swiper,
        },
        on: {
          slideChangeTransitionStart: function () {
            document
              .querySelectorAll(".js-media-sublist")
              [index].swiper.slideTo(
                document.querySelectorAll(".js-media-list")[index].swiper
                  .activeIndex
              );
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
          updatethumbnail();
        }, 800);
      }
    });
  }
};

const subSliderInit = (isUpdate, slidesPerView = 7, spaceBetween = 16) => {
  if (
    document.querySelectorAll(".js-media-sublist") &&
    document.querySelectorAll(".js-media-sublist").length > 0
  ) {
    document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {
      let isCenteringEnabled = true;

      let subSlider = new Swiper(elem, {
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: spaceBetween,
        //slideToClickedSlide: true,
        //watchSlidesProgress: true,
        //updateOnWindowResize: true,
        slidesPerView: 3,
        direction: "horizontal",
        navigation: false,
        freeMode: false,
        initialSlide: 0,
        on: {
          init: function () {
            this.setTranslate(0, 0, 0);
          },
        },
        transitionStart: function () {
          document
            .querySelector(".js-media-list")
            .swiper.slideTo(
              document.querySelectorAll(".js-media-sublist")[index].swiper
                .activeIndex
            );
        },
        breakpoints: {
          576: {
            direction: "vertical",
            slidesPerView: slidesPerView - 0.5,
          },
          750: {
            direction: "vertical",
            slidesPerView: slidesPerView + 1.5,
          },
          990: {
            direction: "vertical",
            slidesPerView: slidesPerView - 0.5,
          },
          1200: {
            direction: "vertical",
            slidesPerView: slidesPerView,
          },
          //1360: {
          //	direction: "vertical",
          //	slidesPerView: slidesPerView - 0.5,
          //},
          1360: {
            direction: "vertical",
            slidesPerView: slidesPerView,
          },
        },
      });

      const checkSlidesAndUpdate = () => {
        if (subSlider.slides.length <= slidesPerView) {
          if (isCenteringEnabled) {
            subSlider.params.centeredSlides = false;
            subSlider.update();
            isCenteringEnabled = false;
          }
        } else {
          if (!isCenteringEnabled) {
            subSlider.params.centeredSlides = true;
            subSlider.update();
            isCenteringEnabled = true;
          }
        }
      };

      checkSlidesAndUpdate();

      subSlider.on("toEdge", checkSlidesAndUpdate);

      const syncSublistHeightFromMainList = () => {
        const listWrapper = elem.closest(".product__media-list-wrapper");
        const mainList = listWrapper?.querySelector(".js-media-list");
        if (!mainList) return;

        let sliderHeight = 0;
        const sw = mainList.swiper;
        if (sw?.slides?.length) {
          const slide = sw.slides[sw.activeIndex] || sw.slides[0];
          sliderHeight = slide?.getBoundingClientRect().height || 0;
        }
        if (!sliderHeight) {
          const slideEl =
            mainList.querySelector(".swiper-slide-active") ||
            mainList.querySelector(".swiper-slide");
          sliderHeight = slideEl?.getBoundingClientRect().height || 0;
        }
        if (!sliderHeight) {
          sliderHeight = mainList.getBoundingClientRect().height;
        }

        if (window.innerWidth > 576 && sliderHeight > 0) {
          elem.style.height = `${Math.round(sliderHeight) - 1}px`;
        } else {
          elem.style.height = "";
        }
      };

      const resizeObserver = new ResizeObserver(() => {
        syncSublistHeightFromMainList();
      });

      const listWrapper = elem.closest(".product__media-list-wrapper");
      const mainListForObserve = listWrapper?.querySelector(".js-media-list");

      const observeTargets = [];
      if (mainListForObserve) observeTargets.push(mainListForObserve);
      if (listWrapper) observeTargets.push(listWrapper);

      const fallbackTarget =
        elem.closest(".quick-add-modal") ||
        document.querySelector(".product-section");

      if (observeTargets.length === 0 && fallbackTarget) {
        observeTargets.push(fallbackTarget);
      }

      observeTargets.forEach((target) => resizeObserver.observe(target));

      if (observeTargets.length > 0) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            syncSublistHeightFromMainList();
          });
        });
      }

      if (isUpdate) {
        setTimeout(() => {
          subSlider.update();
          syncSublistHeightFromMainList();
        }, 800);
      }
    });
  }
};

window.monochromeReinitProductMediaInRoot = function (root) {
  if (!root || typeof root.querySelectorAll !== "function") return;
  root.querySelectorAll(".js-media-list, .js-media-sublist").forEach((el) => {
    if (el.swiper && typeof el.swiper.destroy === "function") {
      el.swiper.destroy(true, true);
    }
  });
  subSliderInit(true);
  sliderInit(true);
  if (typeof updatethumbnail === "function") {
    updatethumbnail();
  }
};

let allSections = document.querySelectorAll("section");

window.addEventListener("resize", () => {
  allSections.forEach((prodSection) => {
    if (prodSection.classList.contains("product-section")) {
      setTimeout(() => {
        updatethumbnail();
      }, 50);
    }
  });
});

document.addEventListener("visibilitychange", function () {
  allSections.forEach((prodSection) => {
    if (prodSection.classList.contains("product-section")) {
      setTimeout(() => {
        updatethumbnail();
      }, 50);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  allSections.forEach((prodSection) => {
    if (prodSection.classList.contains("product-section")) {
      setTimeout(() => {
        updatethumbnail();
      }, 50);
    }
  });
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.input = this.querySelector("input");
    this.isCartItem = Boolean(
      this.closest(".cart-item, .quick-variant-item")
    );
    this.minValue = Number(
      this.input?.getAttribute("min") ?? this.input?.dataset?.min ?? 1
    );

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.setMinimumDisable();

    const eventList = ["paste", "input"];
    for (const event of eventList) {
      this.input.addEventListener(event, (e) => {
        const value = e.currentTarget.value;
        const numberRegex = this.isCartItem ? /^\d*$/ : /^0*?[1-9]\d*$/;

        if (!numberRegex.test(value) && value !== "") {
          e.currentTarget.value = this.minValue;
        }

        this.setMinimumDisable();
      });
    }

    this.input.addEventListener("change", () => this.setMinimumDisable());

    this.input.addEventListener("focusout", (e) => {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = this.minValue;
        this.setMinimumDisable();
      }
    });
  }

  setMinimumDisable() {
    const minusBtn = this.querySelector('button[name="minus"]');
    if (!minusBtn || !this.input) return;

    if (Number(this.input.value) <= Number(this.input.min || this.minValue)) {
      minusBtn.classList.add("disabled");
    } else {
      minusBtn.classList.remove("disabled");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown();
    this.setMinimumDisable();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

class PricePerItem extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.priceEl = this.querySelector("[data-price-per-item-value]");
    this.quantityWrapper = this.closest(".product-form__quantity");
    this.quantityInput = this.quantityWrapper?.querySelector(
      'input[name="quantity"]'
    );
    this.baseFormatted =
      this.priceEl?.textContent?.trim() || "";
    this.priceBreaks = this.getPriceBreaks();

    if (!this.priceEl || !this.quantityInput) return;

    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.quantityInput.addEventListener("input", this.onQuantityChange);
    this.quantityInput.addEventListener("change", this.onQuantityChange);
    this.updatePrice();
  }

  disconnectedCallback() {
    if (!this.quantityInput || !this.onQuantityChange) return;
    this.quantityInput.removeEventListener("input", this.onQuantityChange);
    this.quantityInput.removeEventListener("change", this.onQuantityChange);
  }

  getPriceBreaks() {
    const scriptEl = this.querySelector("[data-price-breaks]");
    if (!scriptEl) return [];

    try {
      const parsed = JSON.parse(scriptEl.textContent);
      return Array.isArray(parsed)
        ? parsed.sort(
            (a, b) => Number(a.minimum_quantity) - Number(b.minimum_quantity)
          )
        : [];
    } catch {
      return [];
    }
  }

  onQuantityChange() {
    this.updatePrice();
  }

  updatePrice() {
    if (!this.priceEl || !this.quantityInput) return;

    const inputQty = Number(this.quantityInput.value || 0);
    const cartQty = Number(this.quantityInput.dataset.cartQuantity || 0);
    const totalQty = inputQty + cartQty;
    let formattedPrice = this.baseFormatted;

    for (let i = this.priceBreaks.length - 1; i >= 0; i -= 1) {
      const priceBreak = this.priceBreaks[i];
      if (totalQty >= Number(priceBreak.minimum_quantity)) {
        formattedPrice = priceBreak.formatted;
        break;
      }
    }

    this.priceEl.textContent = formattedPrice;
  }
}

if (!customElements.get("price-per-item")) {
  customElements.define("price-per-item", PricePerItem);
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    document
      .getElementById("MenuDrawer-Overlay")
      .addEventListener("click", this.closeMenuDrawerOverlay);
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  closeMenuDrawerOverlay() {
    document
      .querySelector(".menu-drawer-container")
      .classList.remove("menu-opening");

    document.querySelector(".menu-drawer-container").removeAttribute("open");
    document
      .querySelector(".header__icon--menu")
      .setAttribute("aria-expanded", false);
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class BurgerDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#BurgerDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

    this.querySelector("#burger-drawer-close").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#burger-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = document.getElementById("BurgerDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".burger__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("burger-drawer", BurgerDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.getAttribute("data-autoplay")) {
              let playPromise = entry.target.play();
              if (playPromise !== undefined) {
                playPromise.then((_) => {}).catch((error) => {});
              }
            }
          } else {
            entry.target.pause();
          }
        });
      });
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (
        deferredElement.nodeName == "VIDEO" ||
        deferredElement.nodeName == "IFRAME"
      ) {
        // force autoplay for safari

        if (this.classList.contains("video-section__media")) {
          let playPromise = deferredElement.play();
          if (playPromise !== undefined) {
            playPromise.then((_) => {}).catch((error) => {});
          }
          videoObserver.observe(deferredElement);
        } else {
          deferredElement.play();
        }
      }
      if (
        this.closest(".swiper")?.swiper.slides[
          this.closest(".swiper").swiper.activeIndex
        ].querySelector("model-viewer")
      ) {
        if (
          !this.closest(".swiper")
            .swiper.slides[
              this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
            .classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class CardDeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.loadContent();
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.getAttribute("data-autoplay")) {
              let playPromise = entry.target.play();
              if (playPromise !== undefined) {
                playPromise.then((_) => {}).catch((error) => {});
              }
            }
            entry.target.play();
          } else {
            entry.target.pause();
          }
        });
      });

      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (
        deferredElement.nodeName == "VIDEO" ||
        deferredElement.nodeName == "IFRAME"
      ) {
        deferredElement.autoplay = true;
        deferredElement.muted = true;
        deferredElement.play();

        let playPromise = deferredElement.play();
        if (playPromise !== undefined) {
          playPromise.then((_) => {}).catch((error) => {});
        }
        videoObserver.observe(deferredElement);
      }
    }
  }
}

customElements.define("card-deferred-media", CardDeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    this.sliderItems = this.querySelectorAll(".slider__slide");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.altMediaGrouping = false;
  }

  connectedCallback() {
    this.syncAltMediaGroupingFlag();
  }

  getProductMediaContainer() {
    const scope = this.getProductScopeRoot();
    const sectionId = this.dataset.section;
    if (!sectionId) return null;
    return (
      scope.querySelector(
        `.product__media-wrapper[data-section="product-media-${sectionId}"]`
      ) ||
      scope.querySelector(`[data-section="product-media-${sectionId}"]`)
    );
  }

  syncAltMediaGroupingFlag() {
    const mediaContainer = this.getProductMediaContainer();
    this.altMediaGrouping =
      mediaContainer?.dataset?.altMediaGrouping === "true";
    return this.altMediaGrouping;
  }

  updateMediaForCurrentVariant() {
    this.syncAltMediaGroupingFlag();
    const featuredMediaId = this.currentVariant?.featured_media?.id;

    if (
      featuredMediaId &&
      (this.dataset?.variantMediaDisplay === "show_all" || this.altMediaGrouping)
    ) {
      const mediaId = `${this.dataset.section}-${featuredMediaId}`;
      this.updateMedia(mediaId);
      return;
    }

    if (
      this.altMediaGrouping &&
      typeof window.updateVariantMediaDisplay === "function"
    ) {
      window.updateVariantMediaDisplay(
        this.dataset.section,
        this.currentVariant
      );
    }
  }

  normalizeShopifyProductPath(url) {
    if (!url || typeof url !== "string") return "";
    try {
      const pathname = new URL(url, window.location.origin).pathname;
      return pathname.replace(/\/+$/, "") || pathname;
    } catch {
      return url.replace(/\/+$/, "");
    }
  }

  syncProductModalFromFetchedHtml(
    html,
    sourceSectionId,
    currentSectionId,
    scope
  ) {
    const modalSrc = html.getElementById(`ProductModal-${sourceSectionId}`);
    const modalDest = scope.querySelector(`#ProductModal-${currentSectionId}`);
    if (!modalSrc || !modalDest) return;
    let nextHtml = modalSrc.innerHTML;
    if (currentSectionId !== sourceSectionId) {
      nextHtml = nextHtml.replaceAll(sourceSectionId, currentSectionId);
    }
    modalDest.innerHTML = nextHtml;
  }

  syncProductFormForCombinedListing(
    html,
    infoSrc,
    infoDest,
    sourceSectionId,
    currentSectionId
  ) {
    const pfSrc = infoSrc.querySelector("product-form.product-form");
    const pfDest = infoDest.querySelector("product-form.product-form");
    if (!pfSrc || !pfDest) return;

    let formMarkup = pfSrc.outerHTML;
    if (currentSectionId !== sourceSectionId) {
      formMarkup = formMarkup.replaceAll(sourceSectionId, currentSectionId);
    }
    const wrap = document.createElement("div");
    wrap.innerHTML = formMarkup.trim();
    const nextForm = wrap.querySelector("product-form");
    if (!nextForm) return;

    pfDest.replaceWith(nextForm);

    if (window.Shopify && Shopify.PaymentButton) {
      try {
        Shopify.PaymentButton.init();
      } catch (err) {}
    }
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    const optionEl = event.target;
    const combinedProductURL = optionEl?.dataset?.productUrl;

    this.updateOptions();

    const targetPath = this.normalizeShopifyProductPath(combinedProductURL);
    const pickerPath = this.normalizeShopifyProductPath(this.dataset.url);
    const isCrossProductCombinedSelection =
      Boolean(combinedProductURL) && targetPath !== pickerPath;

    if (!isCrossProductCombinedSelection) {
      this.updateMasterId();
    } else {
      this.currentVariant = null;
    }

    try {
      this.applyCriticalVariantState();
    } catch (err) {}

    this.toggleAddButton(true, "");

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    // -----
    // checking for high-variant and combined products
    // if variant not found in liquid <script data-all-variants-no-high> and product is high-variant
    if (
      (!this.currentVariant && this.dataset.isHighVariantProduct === "true") ||
      (!this.currentVariant && combinedProductURL)
    ) {
      const selectedValuesIds = this.getSelectedValuesIds();
      this.highVariantRequestUrl = this.createRequestUrl({
        selectedValuesIds: selectedValuesIds,
        combinedProductURL: combinedProductURL,
      });
      if (this.highVariantRequestUrl) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }
    // -----

    if (this.isHighVariantNeedUpdate === false) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
    }
    this.resetErrorMessage();

    if (!this.currentVariant) {
      // -----
      // for high-variant products
      if (this.isHighVariantNeedUpdate) {
        this.classList.add("high-variant-loading");
        this.renderProductInfo(this.highVariantRequestUrl);
        return;
      }
      // -----

      this.toggleAddButton(true, "");
      this.setUnavailable();
    } else {
      this.updateMediaForCurrentVariant();
      this.updateURL();
      this.updateVariantInput();
      const requestUrl = this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      });
      this.renderProductInfo(requestUrl);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(
      this.querySelectorAll(".product-form__controls--dropdown")
    );

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      })
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector("[data-all-variants-no-high]")) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  applyCriticalVariantState() {
    const scope = this.getProductScopeRoot();
    const sectionEscaped = CSS.escape(this.dataset.section);
    const forms = scope.querySelectorAll(
      `#product-form-${sectionEscaped}, #product-form-installment-${sectionEscaped}`
    );

    if (this.currentVariant) {
      forms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) input.value = this.currentVariant.id;
      });
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, window.variantStrings.unavailable);
    } else if (!this.currentVariant.available) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  getProductScopeRoot() {
    return (
      this.closest("quick-add-modal") ||
      this.closest("quick-view-modal") ||
      this.closest("#quick-view") ||
      this.closest('[id^="shopify-section-"]') ||
      document.documentElement
    );
  }

  destroyMediaSwipersWithin(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".js-media-list, .js-media-sublist").forEach((el) => {
      if (el.swiper && typeof el.swiper.destroy === "function") {
        el.swiper.destroy(true, true);
      }
    });
  }

  reinitProductMediaAfterDomSwap() {
    document
      .querySelectorAll(".js-media-list, .js-media-sublist")
      .forEach((el) => {
        if (el.swiper && typeof el.swiper.destroy === "function") {
          el.swiper.destroy(true, true);
        }
      });
    if (typeof subSliderInit === "function") {
      subSliderInit(true);
    }
    if (typeof sliderInit === "function") {
      sliderInit(true);
    }
    if (typeof updatethumbnail === "function") {
      updatethumbnail();
    }
  }

  updateMedia(mediaId) {
    if (!mediaId) return;

    try {
      if (typeof window.updateVariantMediaDisplay === "function") {
        window.updateVariantMediaDisplay(
          this.dataset.section,
          this.currentVariant
        );
      }
    } catch (error) {
      console.error(error);
    }

    const scope = this.getProductScopeRoot();
    const mediaEl =
      scope.querySelector(
        `.product__media-wrapper[data-section="product-media-${this.dataset.section}"]`
      ) ||
      scope.querySelector(
        `[data-section="product-media-${this.dataset.section}"]`
      );
    if (!mediaEl) return;

    // for slider and slider_previews layout
    const sliderEl = mediaEl.querySelector(".js-media-list");
    if (sliderEl && sliderEl.swiper && !sliderEl.swiper.destroyed) {
      const slides = Array.from(sliderEl.swiper.slides || []);
      let targetIndex = slides.findIndex((slide) => {
        return (
          !slide.classList.contains("product__media-item--variant-hidden") &&
          slide.dataset?.mediaId === mediaId
        );
      });

      if (targetIndex === -1) {
        targetIndex = slides.findIndex(
          (slide) =>
            !slide.classList.contains("product__media-item--variant-hidden")
        );
      }

      if (targetIndex !== -1) {
        sliderEl.swiper.slideTo(targetIndex, 800);
      }
    }

    // for stacked / grid layout
    const stackedEl =
      mediaEl.querySelector(
        ".product__media-list[data-desktop-type='stacked_previews']"
      ) ||
      mediaEl.querySelector(
        ".product__media-list[data-desktop-type='stacked']"
      ) ||
      mediaEl.querySelector(".product__media-list__container--large") ||
      mediaEl.querySelector(".product__media-list__container--large-grid");
    if (stackedEl && window.innerWidth >= 990) {
      stackedEl.querySelectorAll("[data-media-id]").forEach((mediaItem) => {
        if (
          mediaItem.classList.contains("product__media-item--variant-hidden")
        ) {
          return;
        }

        const mediaItemId = mediaItem.dataset?.mediaId;
        if (mediaItemId === mediaId) {
          const offset = mediaItem.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: offset - 100, behavior: "smooth" });
        }
      });
    }
  }

  updateURL() {
    if (this.dataset.updateUrl === "false") return;
    const newUrl = this.currentVariant
      ? `${this.dataset.url}?variant=${this.currentVariant.id}`
      : this.dataset.url;

    window.history.replaceState({}, "", newUrl);
  }

  updateVariantInput() {
    const scope = this.getProductScopeRoot();
    const sectionEscaped = CSS.escape(this.dataset.section);
    scope
      .querySelectorAll(
        `#product-form-${sectionEscaped}, #product-form-installment-${sectionEscaped}`
      )
      .forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });

    this.syncMirroredVariantHosts();

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });
  }

  /**
   * When multiple variant hosts share the same data-section inside the PDP / modal scope,
   * keep duplicate dropdown UX (sticky bar clones, etc.) aligned with options + hidden variant id updates.
   */
  syncMirroredVariantHosts() {
    const sectionId = this.dataset.section;
    if (!sectionId) return;
    let escSection;
    try {
      escSection = CSS.escape(sectionId);
    } catch {
      escSection = sectionId;
    }
    const values =
      typeof this.getSelectedValues === "function"
        ? this.getSelectedValues()
        : null;
    if (!values || !values.length) return;

    const scope = this.getProductScopeRoot();
    scope
      .querySelectorAll(
        `variant-selects[data-section="${escSection}"], variant-radios[data-section="${escSection}"]`
      )
      .forEach((host) => {
        if (host === this) return;

        host.querySelectorAll("variant-dropdown-select").forEach((dd) => {
          if (typeof dd.updateCurrentOption === "function") {
            dd.updateCurrentOption(values);
          }
        });

        if (typeof host.setCheckedInputsBySelectedValues === "function") {
          try {
            host.setCheckedInputsBySelectedValues(values);
          } catch (err) {}
        }
      });
  }

  updateVariantStatuses() {
    if (this.dataset.isHighVariantProduct === "true") {
      return;
    }

    const checked = this.querySelector(":checked");
    if (!checked) return;

    const variantData = this.getVariantData();
    const selectedOptionOneVariants = variantData.filter(
      (variant) => String(variant.options[0]) === String(checked.value)
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const prevChecked = inputWrappers[index - 1].querySelector(":checked");
      if (!prevChecked) return;
      const previousOptionSelected = prevChecked.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            String(variant.options[index - 1]) ===
              String(previousOptionSelected)
        )
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const rawVal = input.getAttribute("value");
      const isAvail = listOfAvailableOptions.some(
        (v) => String(v) === String(rawVal)
      );
      if (isAvail) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value")
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];

    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;

      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];

      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }

  getSelectedValues() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    const selectedValues = controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput ? checkedInput.value : null;
    });

    return selectedValues;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`renderProductInfo request failed: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        if (this.isHighVariantNeedUpdate) {
          try {
            this.updateURL();
            this.updatePickupAvailability();
            this.updatePickerInnerHtml(html);
            if (this.currentVariant) {
              this.updateVariantInput();
              if (!this.isCombinedListingsNeedUpdate) {
                this.updateMediaForCurrentVariant();
              }
            }
          } catch (err) {}
        } else if (this.dataset.isHighVariantProduct === "true") {
          // Liquid only exposes partial variant JSON for >250 variants; JS skips
          // updateVariantStatuses — refresh picker markup from fetched section so sold-out/disabled UI matches storefront.
          try {
            this.updatePickerInnerHtml(html);
          } catch (err) {}
        }
        // -----

        this.updateElementsAfterFetch(html);

        if (this.currentVariant) {
          try {
            this.syncMirroredVariantHosts();
            this.updateVariantStatuses();
          } catch (err) {}
        }

        if (!this.currentVariant) {
          this.toggleAddButton(true, "");
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
          return;
        }
        console.error(error);
        try {
          this.applyCriticalVariantState();
        } catch (err) {}
      })
      .finally(() => {
        this.classList.remove("high-variant-loading");
      });
  }

  toggleAddButton(disable = true, text) {
    const scope = this.getProductScopeRoot();
    const sectionEscaped = CSS.escape(this.dataset.section);
    scope
      .querySelectorAll(
        `#product-form-${sectionEscaped}, #product-form-installment-${sectionEscaped}`
      )
      .forEach((productForm) => {
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText =
          addButton.querySelector(".button-label") ||
          addButton.querySelector("span");

        if (disable) {
          addButton.setAttribute("disabled", true);
          addButton.setAttribute("aria-disabled", true);
          if (text) {
            addButtonText.textContent = text;

            if (text === window.variantStrings.unavailable) {
              addButton.dataset.status = "unavailable";
            } else {
              addButton.dataset.status = "sold-out";
            }
          }
        } else {
          addButton.removeAttribute("disabled");
          addButton.removeAttribute("aria-disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
          addButton.dataset.status = "available";
        }
      });
  }

  resetErrorMessage() {
    const scope = this.getProductScopeRoot();
    const sectionEscaped = CSS.escape(this.dataset.section);
    scope
      .querySelectorAll(
        `#product-form-${sectionEscaped}, #product-form-installment-${sectionEscaped}`
      )
      .forEach((productForm) => {
        const parentEl = productForm.closest("product-form");
        if (parentEl) {
          const errorWrapperEl = parentEl.querySelector(
            ".product-form__error-message-wrapper"
          );
          const errorTextEl = errorWrapperEl?.querySelector(
            ".product-form__error-message"
          );
          if (!errorWrapperEl || !errorTextEl) return;
          errorWrapperEl.setAttribute("hidden", true);
          errorTextEl.textContent = "";
        }
      });
  }

  setUnavailable() {
    const scope = this.getProductScopeRoot();
    const sectionEscaped = CSS.escape(this.dataset.section);
    const price = scope.querySelector(`#price-${sectionEscaped}`);
    const inventory = scope.querySelector(`#Inventory-${sectionEscaped}`);
    const sku = scope.querySelector(`#Sku-${sectionEscaped}`);
    const colorNameDestinations = scope.querySelectorAll(
      `[id^='ColorName-${this.dataset.section}']`
    );

    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    const el = this.querySelector("[data-all-variants-no-high]");
    if (!el) {
      return this.variantData || [];
    }
    try {
      this.variantData = JSON.parse(el.textContent.trim());
    } catch {
      this.variantData = [];
    }
    return this.variantData;
  }

  updateElementsAfterFetch(html) {
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const scope = this.getProductScopeRoot();

    const byId = (root, id) => root.querySelector(`#${CSS.escape(id)}`);

    // price
    const priceDestination = byId(scope, `price-${currentSectionId}`);
    const priceSource = html.getElementById(`price-${sourceSectionId}`);

    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = byId(scope, `Inventory-${currentSectionId}`);
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.textContent.trim() === ""
      );
    }

    // sku
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = byId(scope, `Sku-${currentSectionId}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = scope.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const variantSwatchesSource = html.querySelector(
        `#${CSS.escape(
          `variant-picker-${sourceSectionId}`
        )} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = scope.querySelector(
        `#${CSS.escape(
          `variant-picker-${currentSectionId}`
        )} [data-is-variant-image-swatch="true"]`
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        if (currentSectionId !== sourceSectionId) {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML.replaceAll(
              sourceSectionId,
              currentSectionId
            );
        } else {
          variantSwatchesDestination.innerHTML =
            variantSwatchesSource.innerHTML;
        }
      }
    }

    // product media — target outer gallery wrapper (several nodes share data-section in markup)
    // Alt grouping keeps all media in the DOM and filters client-side — do not replace innerHTML.
    // Combined listings always replace the media, since the sibling product has a different set.
    if (
      (this.dataset?.variantMediaDisplay !== "show_all" &&
        !this.syncAltMediaGroupingFlag()) ||
      this.isCombinedListingsNeedUpdate
    ) {
      const resolveMediaSource = () =>
        html.querySelector(
          `.product__media-wrapper[data-section="product-media-${sourceSectionId}"]`
        ) ||
        html.querySelector(`[data-section="product-media-${sourceSectionId}"]`);

      const resolveMediaDestination = () =>
        scope.querySelector(
          `.product__media-wrapper[data-section="product-media-${currentSectionId}"]`
        ) ||
        scope.querySelector(
          `[data-section="product-media-${currentSectionId}"]`
        ) ||
        scope.querySelector(
          ".product__outer .product__column--media .product__media-wrapper"
        ) ||
        scope.querySelector(".product .product__media-wrapper");

      const mediaSource = resolveMediaSource();
      const mediaDestination = resolveMediaDestination();

      if (mediaSource && mediaDestination) {
        const mountRoot =
          this.closest("quick-add-modal") ||
          this.closest("#quick-view") ||
          document.getElementById(`shopify-section-${currentSectionId}`) ||
          scope;

        this.destroyMediaSwipersWithin(mountRoot);

        mediaDestination.innerHTML =
          currentSectionId !== sourceSectionId
            ? mediaSource.innerHTML.replaceAll(
                sourceSectionId,
                currentSectionId
              )
            : mediaSource.innerHTML;

        if (mediaSource.dataset.altMediaGrouping === "true") {
          mediaDestination.dataset.altMediaGrouping = "true";
          if (mediaSource.dataset.groupOptionPosition) {
            mediaDestination.dataset.groupOptionPosition =
              mediaSource.dataset.groupOptionPosition;
          }
        } else {
          delete mediaDestination.dataset.altMediaGrouping;
          delete mediaDestination.dataset.groupOptionPosition;
        }
        if (mediaSource.dataset.variantMediaDisplay) {
          mediaDestination.dataset.variantMediaDisplay =
            mediaSource.dataset.variantMediaDisplay;
        }

        this.syncProductModalFromFetchedHtml(
          html,
          sourceSectionId,
          currentSectionId,
          scope
        );

        const parentQuickViewModal = this.closest("quick-add-modal");
        const parentFeaturedProduct = this.closest(".featured-product");

        if (
          parentQuickViewModal &&
          typeof parentQuickViewModal.removeDOMElements === "function"
        ) {
          parentQuickViewModal.removeDOMElements(mediaDestination);
        }

        if (
          parentFeaturedProduct &&
          typeof window.initFeaturedProduct === "function"
        ) {
          const section = document.getElementById(
            `shopify-section-${currentSectionId}`
          );
          if (section) window.initFeaturedProduct(section);
        } else {
          this.reinitProductMediaAfterDomSwap();
        }

        this.syncAltMediaGroupingFlag();
        if (
          this.altMediaGrouping &&
          typeof window.updateVariantMediaDisplay === "function"
        ) {
          window.updateVariantMediaDisplay(
            this.dataset.section,
            this.currentVariant
          );
        }
      }
    }

    // combined listings — title / subtitle in this product only
    if (this.isCombinedListingsNeedUpdate) {
      const variantScript = html.querySelector("[data-selected-variant]");
      const raw = variantScript?.textContent?.trim();
      let selectedVariant = null;
      try {
        selectedVariant = raw ? JSON.parse(raw) : null;
      } catch {
        selectedVariant = null;
      }

      const mainProdSrc =
        html.getElementById(`MainProduct-${sourceSectionId}`) ||
        html.querySelector('[id^="MainProduct-"]');
      const titleFromMarkup = mainProdSrc?.querySelector(".product__title");
      if (titleFromMarkup) {
        const nextTitle = titleFromMarkup.textContent?.trim();
        if (nextTitle) {
          scope.querySelectorAll(".product__title").forEach((el) => {
            el.textContent = nextTitle;
          });
        }
      } else if (selectedVariant?.name) {
        const slashIdx = selectedVariant.name.indexOf(" / ");
        const productTitle =
          slashIdx !== -1
            ? selectedVariant.name.slice(0, slashIdx).trim()
            : selectedVariant.name.split(" - ")[0];
        if (productTitle) {
          scope.querySelectorAll(".product__title").forEach((el) => {
            el.textContent = productTitle;
          });
        }
      }

      const textDest = scope.querySelector(
        ".product__info-wrapper .product__text"
      );
      const textSrc = html.querySelector(
        ".product__info-wrapper .product__text"
      );
      if (textDest && textSrc) {
        textDest.innerHTML = textSrc.innerHTML;
      }

      const recSrc = html.querySelector("product-recommendations--single");
      const recDest = scope.querySelector("product-recommendations--single");
      if (recSrc && recDest) {
        let recMarkup = recSrc.outerHTML;
        if (currentSectionId !== sourceSectionId) {
          recMarkup = recMarkup.replaceAll(sourceSectionId, currentSectionId);
        }
        const recWrap = document.createElement("div");
        recWrap.innerHTML = recMarkup;
        const nextRec = recWrap.querySelector(
          "product-recommendations--single"
        );
        if (nextRec) {
          recDest.replaceWith(nextRec);
        }
      }
    }

    const cloneSubtreeForCurrentSection = (el) => {
      if (!el) return null;
      const wrap = document.createElement("div");
      let markup = el.outerHTML;
      if (currentSectionId !== sourceSectionId) {
        markup = markup.replaceAll(sourceSectionId, currentSectionId);
      }
      wrap.innerHTML = markup;
      return wrap.firstElementChild;
    };

    const resolveProductInfo = (root, sectionIdForInfoId) => {
      return (
        byId(root, `ProductInfo-${sectionIdForInfoId}`) ||
        root.querySelector('[id^="ProductInfo-"]')
      );
    };

    const infoSrc = resolveProductInfo(html, sourceSectionId);
    const infoDest = resolveProductInfo(scope, currentSectionId);
    if (infoSrc && infoDest) {
      const srcTags = infoSrc.querySelector("ul.product-tags");
      const dstTags = infoDest.querySelector("ul.product-tags");
      if (srcTags && dstTags) {
        const nextTags = cloneSubtreeForCurrentSection(srcTags);
        if (nextTags) dstTags.replaceWith(nextTags);
      } else if (dstTags && !srcTags) {
        dstTags.remove();
      } else if (srcTags && !dstTags) {
        const nextTags = cloneSubtreeForCurrentSection(srcTags);
        const titleWrap = infoDest.querySelector(".product__title__wrapper");
        if (nextTags) {
          if (titleWrap) {
            titleWrap.insertAdjacentElement("afterend", nextTags);
          } else {
            infoDest.prepend(nextTags);
          }
        }
      }

      const getDescriptionSyncRoot = (root) => {
        const fixed =
          root.querySelector(
            ".product__description-fixed.main-product-description"
          ) || root.querySelector(".product__description-fixed");
        if (fixed) return fixed;
        const md = root.querySelector(
          ".product-about__accordion-content.main-product-description"
        );
        if (md) return md.closest(".product-about");
        const md2 = root.querySelector(".main-product-description");
        if (md2) return md2.closest(".product-about");
        return null;
      };
      const srcDescRoot = getDescriptionSyncRoot(infoSrc);
      const dstDescRoot = getDescriptionSyncRoot(infoDest);
      if (srcDescRoot && dstDescRoot) {
        const nextDesc = cloneSubtreeForCurrentSection(srcDescRoot);
        if (nextDesc) dstDescRoot.replaceWith(nextDesc);
      } else if (dstDescRoot && !srcDescRoot) {
        dstDescRoot.remove();
      } else if (srcDescRoot && !dstDescRoot) {
        const nextDesc = cloneSubtreeForCurrentSection(srcDescRoot);
        const anchor =
          infoDest.querySelector("ul.product-tags") ||
          infoDest.querySelector(".product__title__wrapper");
        if (nextDesc) {
          if (anchor) {
            anchor.insertAdjacentElement("afterend", nextDesc);
          } else {
            infoDest.appendChild(nextDesc);
          }
        }
      }

      if (this.isCombinedListingsNeedUpdate) {
        this.syncProductFormForCombinedListing(
          html,
          infoSrc,
          infoDest,
          sourceSectionId,
          currentSectionId
        );
      }

      const buttonsSrc = infoSrc.querySelector(".product-form__buttons");
      const buttonsDest = infoDest.querySelector(".product-form__buttons");
      if (buttonsSrc && buttonsDest) {
        const sourceHasQuantityPricing =
          buttonsSrc.dataset.hasQuantityPricing === "true";
        const destHadQuantityPricing =
          buttonsDest.dataset.hasQuantityPricing === "true";

        if (sourceHasQuantityPricing || destHadQuantityPricing) {
          if (sourceHasQuantityPricing) {
            buttonsDest.dataset.hasQuantityPricing = "true";
          } else {
            buttonsDest.removeAttribute("data-has-quantity-pricing");
          }

          const sourceB2bEl = buttonsSrc.querySelector(".product-b2b-elements");
          const destB2bEl = buttonsDest.querySelector(".product-b2b-elements");
          if (sourceB2bEl && destB2bEl) {
            destB2bEl.innerHTML = sourceB2bEl.innerHTML;
          } else if (sourceB2bEl && !destB2bEl) {
            buttonsDest.insertAdjacentHTML("afterbegin", sourceB2bEl.outerHTML);
          } else if (!sourceB2bEl && destB2bEl) {
            destB2bEl.remove();
          }

          const sourceQuantityWrapper = buttonsSrc.querySelector(
            ".product-form__quantity"
          );
          const destQuantityWrapper = buttonsDest.querySelector(
            ".product-form__quantity"
          );
          if (sourceQuantityWrapper && destQuantityWrapper) {
            let quantityHtml = sourceQuantityWrapper.innerHTML;
            if (currentSectionId !== sourceSectionId) {
              quantityHtml = quantityHtml.replaceAll(
                sourceSectionId,
                currentSectionId
              );
            }
            destQuantityWrapper.innerHTML = quantityHtml;
          }
        }
      }
    }
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
  }) {
    const productUrl = combinedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (currentVariantId) {
      return `${productUrl}?variant=${currentVariantId}&section_id=${sectionId}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
    // -----
  }

  /**
   * innerHTML replace does not update the custom element host. After combined listing
   * switches to another product, keep data-url / data-is-high-variant-product in sync
   * with the fetched section HTML.
   */
  syncVariantPickerHostAttributesFromFetchedSource(sourceHost, destHost) {
    if (!sourceHost || !destHost) return;
    const ATTRS = [
      "data-url",
      "data-is-high-variant-product",
      "data-update-url",
      "data-variant-media-display",
    ];
    ATTRS.forEach((attr) => {
      if (sourceHost.hasAttribute(attr)) {
        destHost.setAttribute(attr, sourceHost.getAttribute(attr));
      }
    });
    if (destHost.closest?.("quick-add-modal")) {
      destHost.setAttribute("data-update-url", "false");
    }
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-picker-${this.dataset.section}`
    );
    if (!variantPickerSource || !variantPickerDestination) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const raw = newVariantDataEl.textContent?.trim();
    let selectedVariant = null;
    try {
      selectedVariant = raw ? JSON.parse(raw) : null;
    } catch {
      selectedVariant = null;
    }

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestination.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl && raw) {
      oldEl.textContent = raw;
    }
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-picker-${currentSectionId}`
    );

    if (variantPickerSource && variantPickerDestination) {
      variantPickerDestination.innerHTML =
        currentSectionId !== sourceSectionId
          ? variantPickerSource.innerHTML.replaceAll(
              sourceSectionId,
              currentSectionId
            )
          : variantPickerSource.innerHTML;

      this.syncVariantPickerHostAttributesFromFetchedSource(
        variantPickerSource,
        variantPickerDestination
      );

      this.variantData = null;
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const rawVal = input.getAttribute("value");
      const isAvail = listOfAvailableOptions.some(
        (v) => String(v) === String(rawVal)
      );
      if (isAvail) {
        input.classList.remove("disabled");
        input.disabled = false;
      } else {
        input.classList.add("disabled");
        //input.disabled = true;
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}

class VariantDropdownSelect extends HTMLElement {
  constructor() {
    super();

    this.currentEl = this.querySelector(".dropdown-select__current");
    this.optionsWrapperEl = this.querySelector(".dropdown-select__options");
    this.hiddenInput = this.querySelector("input[type='hidden']");
    if (!this.currentEl || !this.optionsWrapperEl || !this.hiddenInput) return;

    this.optionsEls = Array.from(this.optionsWrapperEl.querySelectorAll("li"));
    this.inputs = Array.from(this.optionsWrapperEl.querySelectorAll("input"));
    this.hasColorSwatch = this.currentEl?.classList?.contains(
      "dropdown-select__current--with-color"
    );
    this.isActive = false;

    this.optionPosition = this.getOptionPosition();
    this._onCurrentClick = this.onCurrentClick.bind(this);
    this._onKeyUp = this.onKeyUp.bind(this);
    this._onOptionsClick = this.onClickOption.bind(this);
    this._onKeyUpOptions = this.onKeyUpOptions.bind(this);
    this._onOutsideClick = this.onOutsideClick.bind(this);
  }

  connectedCallback() {
    this.currentEl.addEventListener("click", this._onCurrentClick);
    this.currentEl.addEventListener("keyup", this._onKeyUp);
    this.currentEl.addEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.addEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.addEventListener("keyup", this._onKeyUpOptions);
    document.addEventListener("click", this._onOutsideClick);
  }

  disconnectedCallback() {
    this.currentEl.removeEventListener("click", this._onCurrentClick);
    this.currentEl.removeEventListener("keyup", this._onKeyUp);
    this.currentEl.removeEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.removeEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.removeEventListener("keyup", this._onKeyUpOptions);
    document.removeEventListener("click", this._onOutsideClick);
  }

  onCurrentClick(event) {
    event.stopPropagation();
    if (this.isActive) {
      this.onClose();
    } else {
      this.onOpen();
    }
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() === "ENTER") {
      event.preventDefault();
      event.stopPropagation();
      if (this.isActive) {
        this.onClose();
      } else {
        this.onOpen();
      }
    }
  }

  preventDoubleClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onClickOption(event) {
    const optionEl = event.target.closest("li");
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (
      !optionEl ||
      !currentValueEl ||
      !this.optionsWrapperEl.contains(optionEl)
    ) {
      event.preventDefault();
      return;
    }

    const newValue = optionEl.dataset.value;

    if (this._lastHandledValue === newValue && event.target.tagName === "INPUT") {
      this._lastHandledValue = null;
      return;
    }
    this._lastHandledValue = newValue;

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    if (this.hasColorSwatch) {
      const newColor = optionEl.dataset.color;
      this.hiddenInput.dataset.colorSwatch = newColor;
      this.currentEl.style.setProperty("--swatch-color", newColor);
    }

    const optionInput = optionEl.querySelector('input[type="radio"]');
    this.inputs.forEach((el) => el.removeAttribute("checked"));
    if (optionInput) {
      optionInput.checked = true;
      optionInput.setAttribute("checked", "true");
    }

    this.hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));

    this.onClose();
    this.currentEl.focus();
  }

  onKeyUpOptions(event) {
    if (event.code === "Escape" && this.isActive) {
      event.preventDefault();
      this.onClose();
      this.currentEl.focus();
    }
  }

  onOpen() {
    document.querySelectorAll("variant-dropdown-select").forEach((dropdown) => {
      if (dropdown !== this && typeof dropdown.onClose === "function") {
        dropdown.onClose();
      }
    });

    this.optionsWrapperEl.classList.add("active");
    this.currentEl.setAttribute("aria-expanded", "true");
    this.isActive = true;

    const currentIndex = this.inputs.findIndex((inp) =>
      inp.hasAttribute("checked")
    );
    this.inputs[currentIndex >= 0 ? currentIndex : 0]?.focus();
  }

  onClose() {
    this.optionsWrapperEl.classList.remove("active");
    this.currentEl.setAttribute("aria-expanded", "false");
    this.isActive = false;
  }

  onOutsideClick(event) {
    if (!this.isActive || this.contains(event.target)) return;
    this.onClose();
  }

  getOptionPosition() {
    const parentFieldset = this.closest(".product-form__controls");
    return Number(parentFieldset?.dataset?.optionPosition || -1);
  }

  updateCurrentOption(selectedValues = []) {
    // Method is used to synchronize after changes options in sticky bar.
    if (this.optionPosition === -1) return;
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (!currentValueEl || !selectedValues || !selectedValues.length) return;

    const newValue = selectedValues[this.optionPosition - 1];

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    this.optionsEls.forEach((optionEl) => {
      const liDataValue = optionEl.dataset.value;
      if (newValue === liDataValue && this.hasColorSwatch) {
        const newColor = optionEl.dataset.color;
        this.hiddenInput.dataset.colorSwatch = newColor;
        this.currentEl.style.setProperty("--swatch-color", newColor);
      }
    });
  }
}

if (!customElements.get("variant-dropdown-select")) {
  customElements.define("variant-dropdown-select", VariantDropdownSelect);
}

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );

    const $this = this;

    this.querySelector(".shopify-model-viewer-ui__button").addEventListener(
      "click",
      function () {
        if (
          $this
            .closest(".swiper")
            .swiper.slides[
              $this.closest(".swiper").swiper.activeIndex
            ].querySelector("model-viewer")
        ) {
          if (
            !$this
              .closest(".swiper")
              .swiper.slides[
                $this.closest(".swiper").swiper.activeIndex
              ].querySelector("model-viewer")
              .classList.contains("shopify-model-viewer-ui__disabled")
          ) {
            if (
              $this
                .querySelector(".shopify-model-viewer-ui__button")
                .hasAttribute("hidden")
            ) {
              $this.closest(".swiper").swiper.params.noSwiping = true;
              $this.closest(".swiper").swiper.params.noSwipingClass =
                "swiper-slide";
            }
          }
        }
      }
    );

    this.querySelector(
      ".shopify-model-viewer-ui__controls-overlay"
    ).addEventListener("click", function () {
      if (
        !$this
          .querySelector(".shopify-model-viewer-ui__button")
          .hasAttribute("hidden")
      ) {
        $this.closest(".swiper").swiper.params.noSwiping = false;
      }
    });
  }
}
customElements.define("product-model", ProductModel);

// Product slider

(function () {
  const productSlider = () => {
    const productSliders = document.querySelectorAll(".section-slider");
    if (!productSliders.length) return;
    productSliders.forEach((slider) => {
      if (slider.classList.contains("slider_started")) return;

      slider.classList.add("slider_started");
      const sectionId = slider.dataset.id;
      const perRow = +slider.dataset.perRow;
      const mobile = +slider.dataset.mobile;
      let perRowTablet;
      let perRowDesktop;
      let perRowLarge;
      const speed = slider.dataset.speed * 1000;
      const delay = slider.dataset.delay * 1000;
      const autoplay = slider.dataset.autoplay === "true";
      const stopAutoplay = slider.dataset.stopAutoplay === "true";
      const showArrows = slider.dataset.showArrows === "true";
      let autoplayParm = {};
      let arrowsParm = {};
      let PerView = 0.2;
      if (perRow == 2) {
        PerView = 0.6;
      }
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      }
      if (showArrows) {
        arrowsParm = {
          navigation: {
            nextEl: `#${sectionId} .swiper-btn--next`,
            prevEl: `#${sectionId} .swiper-btn--prev`,
          },
          pagination: {
            el: `#${sectionId} .products-slider-pagination`,
            clickable: true,
          },
        };
      }
      const wrapper = slider.querySelector(".popular-product__wrapper");
      if (!wrapper) return;

      const containerOuter =
        (document.body.offsetWidth - wrapper.offsetWidth) / 2;

      const paginationEl = slider.querySelector(".swiper-pagination");
      if (paginationEl) {
        paginationEl.style.paddingLeft = `${containerOuter}px`;
      } else {
        console.warn("Element not found or containerOuter is invalid", {
          sectionId,
          containerOuter,
        });
      }
      const buttonNext = document.querySelector(
        `#${sectionId} .swiper-button-next`
      );
      const buttonPrev = document.querySelector(
        `#${sectionId} .swiper-button-prev`
      );
      if (buttonNext && buttonPrev) {
        if (window.innerWidth >= 1200) {
          const buttonOffset = +containerOuter - 21;

          buttonNext.style.right = `${buttonOffset}px`;
          buttonPrev.style.left = `${buttonOffset}px`;
        } else {
          buttonNext.style.right = `${containerOuter + 21}px`;
          buttonPrev.style.left = `${containerOuter + 21}px`;
        }
      }

      const sectionHeader = document.querySelector(
        ".section-slider .popular-product__wrapper"
      );
      let columnGaps = (perRow - 1) * 16;
      let oneCard = (sectionHeader.offsetWidth - columnGaps) / perRow;
      let perViewRightOffset = +((containerOuter * 2) / oneCard).toFixed(3);

      perViewRightOffset =
        +((containerOuter * 2) / oneCard).toFixed(3) -
        +(perViewRightOffset / oneCard) * 16;

      if (perRow == 1) {
        perRowTablet = perRowDesktop = perRowLarge = 1 + perViewRightOffset;
      } else {
        let columnGapsTablet = (2 - 1) * 16;
        let columnGaps = (3 - 1) * 16;
        let oneCard = (sectionHeader.offsetWidth - columnGaps) / 3;
        let oneCardTablet = (sectionHeader.offsetWidth - columnGapsTablet) / 2;

        let perViewRightOffsetDekstop =
          +((containerOuter * 2) / oneCard).toFixed(3) -
          +(perViewRightOffset / oneCard) * 16;
        let perViewRightOffsetTablet =
          +((containerOuter * 2) / oneCardTablet).toFixed(3) -
          +(perViewRightOffset / oneCardTablet) * 16;

        perRowTablet = 2 + perViewRightOffsetTablet;
        perRowDesktop = 3 + perViewRightOffsetDekstop;
        perRowLarge = perRow + perViewRightOffset;
      }
      if (perRow == 2) {
        perRowTablet = perRowDesktop = perRowLarge = 2 + perViewRightOffset;
      }

      let swiperParms = {
        speed,
        slidesPerView: mobile,
        slidesOffsetBefore: containerOuter,
        keyboard: true,
        mousewheel: { forceToAxis: true },
        breakpoints: {
          576: {
            slidesPerView: perRowTablet + PerView,
          },
          750: {
            slidesPerView: perRowTablet + PerView,
          },
          990: {
            slidesPerView: perRowDesktop + PerView,
          },
          1200: {
            slidesPerView: +perRow + perViewRightOffset + PerView,
          },
          1800: {
            slidesPerView: perRowLarge + PerView,
          },
          2000: {
            slidesPerView: perRowLarge + PerView,
          },
        },
        ...arrowsParm,
        pagination: {
          el: slider.querySelector(".products-slider-pagination"),
          clickable: true,
        },
      };

      if (autoplay) {
        swiperParms.autoplay = {
          delay,
          pauseOnMouseEnter: stopAutoplay,
          disableOnInteraction: false,
        };
      }

      slider.swiperInstance = new Swiper(
        slider.querySelector(".swiper"),
        swiperParms
      );
    });
  };

  function toBoolean(string) {
    return string === "true" ? true : false;
  }
  if (document.querySelector("product-recommendations") !== null) {
    const initslider = setInterval(() => {
      if (
        document
          .querySelector("product-recommendations")
          .querySelector(".swiper") !== null
      ) {
        if (
          document
            .querySelector("product-recommendations")
            .querySelector(".swiper")
            .classList.contains("swiper-initialized")
        ) {
          clearInterval(initslider);
        }
        productSlider();
      }
    }, 100);
  }
  document.addEventListener("DOMContentLoaded", function () {
    productSlider();
    document.addEventListener("shopify:section:load", function () {
      productSlider();
    });
  });
  window.addEventListener("resize", function () {
    document.querySelectorAll(".section-slider").forEach((slider) => {
      if (slider.swiperInstance) {
        slider.swiperInstance.destroy(true, true);
        slider.swiperInstance = null;
      }
      slider.classList.remove("slider_started");
    });

    productSlider();
  });
})();

(function () {
  const initDrawerAccordion = () => {
    $(".drawer__accordion-title")
      .off("click")
      .on("click", function (e) {
        e.stopPropagation();

        const $title = $(this);
        const $content = $title.next(".drawer__accordion-content");
        const $parentContainer = $title.parent().parent();

        if (!$title.hasClass("active")) {
          $parentContainer
            .find(
              "> .medium-font > .drawer__accordion-title.active, > .drawer__accordion-title.active"
            )
            .not($title)
            .removeClass("active");

          $parentContainer
            .find(
              "> .medium-font > .drawer__accordion-content, > .drawer__accordion-content"
            )
            .not($content)
            .stop()
            .slideUp(300);

          $title.addClass("active");
          $content.stop().slideDown(300);
        } else {
          $title.removeClass("active");
          $content.stop().slideUp(300);
        }
      });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initDrawerAccordion();
    document.addEventListener("shopify:section:load", function () {
      initDrawerAccordion();
    });
  });
})();

(function () {
  let image = document.querySelectorAll(".data-alt img");
  image &&
    image.forEach((img, index) => {
      img.alt = "Video background";
    });
})();

(function () {
  const animatedText = () => {
    document.querySelectorAll(".animated-text").forEach((animatedText) => {
      const text = animatedText.dataset.text;

      animatedText.innerHTML = text
        .split(/(\s+)/)
        .map((chunk) => {
          if (chunk.trim() === "") {
            //return '<span class="space">&nbsp;</span>';
            return;
          }
          return `<span class="word">${[...chunk]
            .map(
              (letter) =>
                `<span class="letter_wrapper"><span class="letter">${letter}</span></span>`
            )
            .join("")}</span>`;
        })
        .join("");

      const words = animatedText.querySelectorAll(".word");
      words.forEach((word, index) => {
        const lastLetterWrapper = word.querySelector(
          ".letter_wrapper:last-child"
        );
        if (lastLetterWrapper && index < words.length - 1) {
          const space = document.createElement("span");
          space.classList.add("space");
          space.innerHTML = "&nbsp;";
          word.appendChild(space);
        }
      });

      const letters = animatedText.querySelectorAll(".letter, .space");

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            letters.forEach((letter, index) => {
              setTimeout(() => {
                letter.classList.add("visible");
              }, Math.min(index * 15, 450)); // OD: schnellere Textanimation (vorher index * 70)
            });
            observer.disconnect();
          }
        },
        { threshold: 0.1 }
      );

      observer.observe(animatedText);
    });
  };
  document.addEventListener("DOMContentLoaded", function () {
    animatedText();
    document.addEventListener("shopify:section:load", function () {
      animatedText();
    });
  });
})();

//(function () {
//	const animatedText = () => {
//		// Function to wrap each word and letters within a word
//		const wrapLetters = (node) => {
//			if (node.nodeType === Node.TEXT_NODE) {
//				// If it's a text node and consists only of spaces, remove it
//				if (!node.textContent.trim()) {
//					return "";
//				}
//				// Split the text into words and letters
//				return node.textContent
//					.split(" ") // Split by spaces
//					.map((word) => {
//						if (word === "") {
//							return `<span class="space">&nbsp;</span>`; // Keep space as a span
//						}
//						// Wrap each word in a span and each letter within that word
//						return `<span class="word">${[...word]
//							.map((char) => `<span class="letter_wrapper"><span class="letter">${char}</span></span>`)
//							.join("")}</span>`;
//					})
//					.join(" ");
//			} else if (node.nodeType === Node.ELEMENT_NODE) {
//				// If the element is empty (no content), skip it
//				if (!node.innerHTML.trim()) {
//					return "";
//				}
//				const tagName = node.tagName.toLowerCase();
//				const attributes = [...node.attributes]
//					.map((attr) => `${attr.name}="${attr.value}"`)
//					.join(" ");
//				// Recursively process the element's content
//				const wrappedContent = Array.from(node.childNodes)
//					.map(wrapLetters)
//					.join("");
//				if (!wrappedContent.trim()) {
//					return ""; // Skip if the processed content is empty
//				}
//				// Rebuild the tag with wrapped content inside it
//				return `<${tagName} ${attributes}>${wrappedContent}</${tagName}>`;
//			}
//			return ""; // Ignore other types of nodes
//		};

//		// Main function to process all elements with the class .animated-text
//		document.querySelectorAll(".animated-text").forEach((animatedText) => {
//			// Save the original content of the element
//			const originalContent = animatedText.innerHTML;

//			// Process the text including nested tags
//			animatedText.innerHTML = Array.from(
//				document.createRange().createContextualFragment(originalContent).childNodes
//			)
//				.map(wrapLetters)
//				.join("");

//			// Find all letters and spaces
//			const elements = animatedText.querySelectorAll(".letter, .space");

//			// Observer for text appearance
//			const observer = new IntersectionObserver(
//				([entry]) => {
//					if (entry.isIntersecting) {
//						elements.forEach((element, index) => {
//							setTimeout(() => {
//								element.classList.add("visible");
//							}, index * 100); // Adding a delay to animate each letter
//						});
//						observer.disconnect();
//					}
//				},
//				{ threshold: 0.1 }
//			);

//			observer.observe(animatedText);
//		});
//	 };
//	 document.addEventListener("DOMContentLoaded", function () {
//		animatedText();
//		document.addEventListener("shopify:section:load", function () {
//			animatedText();
//		});
//	});
//})();

(function () {
  const initAnimated = () => {
    const blocks = document.querySelectorAll(".animated-block:not(.visible)");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const block = entry.target;
            block.classList.add("visible");
            observer.unobserve(block);
          }
        });
      },
      { threshold: 0.1 }
    );

    blocks.forEach((block) => {
      observer.observe(block);
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initAnimated();
    document.addEventListener("shopify:section:load", function () {
      initAnimated();
    });
  });
})();

const toggleButton = document.querySelector(".button_write");
if (toggleButton) {
  toggleButton.addEventListener("click", function () {
    const modal = document.querySelector(".comment-form");
    modal.classList.toggle("active");
  });
}

// Buttons animation

function buttonHoverEffects() {
  if (window.innerWidth < 1200) return;
  function wrapLetters(element) {
    const text = element.textContent.trim();
    element.innerHTML = "";

    const wrapperSpan = document.createElement("span");
    wrapperSpan.className = "wrapper";

    Array.from(text).forEach((char, charIndex) => {
      const charSpan = document.createElement("span");
      charSpan.className = "char";
      charSpan.textContent = char;
      charSpan.style.setProperty("--char-index", charIndex + 1);
      wrapperSpan.appendChild(charSpan);
    });

    element.appendChild(wrapperSpan);
  }

  document.querySelectorAll("[hoverstagger='text']").forEach(wrapLetters);
}

document.addEventListener("DOMContentLoaded", buttonHoverEffects);
document.addEventListener("shopify:section:load", buttonHoverEffects);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.enableMockTimer =
      this.getAttribute("data-enable-mock-timer") === "true";

    if (this.enableMockTimer) {
      // get data for infinite mock timer
      const INFINITE_DAYS = Number(this.getAttribute("data-mock-end-day") || 2);
      const DIFF_HOURS = Number(this.getAttribute("data-mock-end-hour") || 3);
      const now = new Date();
      const futureDate = new Date(
        now.getTime() + (INFINITE_DAYS * 24 + DIFF_HOURS) * 60 * 60 * 1000
      );
      const year = futureDate.getFullYear();
      const month = String(futureDate.getMonth() + 1).padStart(2, "0");
      const day = String(futureDate.getDate()).padStart(2, "0");
      const hours = String(futureDate.getHours()).padStart(2, "0");
      const minutes = String(futureDate.getMinutes()).padStart(2, "0");
      this.endDate = `${year}-${month}-${day}`;
      this.endTime = `${hours}:${minutes}`;
    } else {
      // get data from section settings
      this.endDate = this.getAttribute("data-end-date");
      this.endTime = this.getAttribute("data-end-time");
    }
    // ----------------------------------------------------------------
    this.interval;
    this.isStarted = false;
    this.setInterval(this.endDate, this.endTime);
  }

  onInit(endDate, endTime) {
    this.completeBehavior = this.getAttribute("data-complete-behavior");
    this.parentEl = this.closest(".section-countdown-timer");
    this.countdownTimerEl = this.querySelector(".countdown-timer__timer");
    this.countdownEndEl = this.querySelector(".countdown-timer__end");
    this.daysEl = this.querySelector(".js-countdown-timer-days");
    this.hoursEl = this.querySelector(".js-countdown-timer-hours");
    this.minutesEl = this.querySelector(".js-countdown-timer-minutes");
    this.secondsEl = this.querySelector(".js-countdown-timer-seconds");
    // ----------------------------------------------------------------
    const countdownDate = new Date(`${endDate}T${endTime}`);
    const now = new Date();
    const distance = countdownDate.getTime() - now.getTime();
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // ----------------------------------------------------------------
    if (distance < 0 && this.completeBehavior === "hide_block") {
      if (this.parentEl) {
        this.parentEl.style.display = "none";
      }
      this.style.display = "none";
      clearInterval(this.interval);
    } else if (distance < 0 && this.completeBehavior === "show_message") {
      if (this.countdownTimerEl) {
        this.countdownTimerEl.style.display = "none";
      }
      if (this.countdownEndEl) {
        this.countdownEndEl.style.display = "flex";
      }
      clearInterval(this.interval);
    } else {
      if (this.daysEl) {
        this.daysEl.textContent = this.getTwoDigitTime(days);
      }

      if (this.hoursEl) {
        this.hoursEl.textContent = this.getTwoDigitTime(hours);
      }

      if (this.minutesEl) {
        this.minutesEl.textContent = this.getTwoDigitTime(minutes);
      }

      if (this.secondsEl) {
        this.secondsEl.textContent = this.getTwoDigitTime(seconds);
      }
    }
  }

  getTwoDigitTime(time) {
    if (String(time).length === 1) {
      return "0" + time;
    }
    if (String(time) === "-1") {
      return "00";
    }
    return time;
  }

  setInterval(endDate, endTime) {
    clearInterval(this.interval);
    this.interval = setInterval(this.onInit.bind(this, endDate, endTime), 1000);
  }
}

if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

function mergeCartIconBubbleFromSectionHtml(htmlString, rootSelector) {
  const cartLink = document.getElementById("cart-icon-bubble");
  if (!cartLink || !htmlString) return false;
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  const root = rootSelector ? doc.querySelector(rootSelector) : doc.body;
  if (!root) return false;
  const newBubble = root.querySelector(".cart-count-bubble");
  const oldBubble = cartLink.querySelector(".cart-count-bubble");
  if (!newBubble || !oldBubble) return false;
  oldBubble.outerHTML = newBubble.outerHTML;
  return true;
}

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-icon-bubble", mergeCartBubble: true },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".cart-items-wrapper" },
    { id: "main-cart-footer", selector: ".cart__footer" },
    { id: "main-cart-shipping", selector: ".cart-shipping" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        if (section.mergeCartBubble) {
          mergeCartIconBubbleFromSectionHtml(html, ".shopify-section");
          return;
        }
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});

// CART REFRESH EVENT END
// -----------------------------------------------------------------------------
